import React from 'react';

import { Alert, Dialog, DialogContent, Stack, TextField } from '@mui/material';

type Props = { onClose: () => void; url: string; label: string; copied?: boolean };

export default function SpoofLinkDialog({ onClose, url, label, copied = true }: Props) {
  return (
    <Dialog open onClose={onClose}>
      <DialogContent>
        <Stack direction="column" spacing={2} sx={{ my: 2 }}>
          <Alert severity="warning" onClose={onClose}>
            Extreme caution, paste into incognito only
          </Alert>
          <Alert severity="info" onClose={onClose}>
            {copied
              ? 'Your link has been copied to the clipboard!'
              : 'Your link could not be copied automatically. Select and copy the link below.'}
          </Alert>
          <TextField
            InputLabelProps={{ shrink: true }}
            label={label}
            value={url}
            multiline
            disabled={copied}
            InputProps={{ readOnly: true }}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
